import React, { useContext } from 'react';
import classNames from 'classnames';
import css_slice from './SliceHeroSubpage.module.scss';
import { graphql } from 'gatsby';
import HeroSubpage from '@components/HeroSubpage/HeroSubpage';

import ThemeContext from '@prismic/contexts/ThemeContext';
import { PrismicButton } from '../../../Button/Button';

const SliceHeroSubpage = ({ slice }) => {
  const css = useContext(ThemeContext);

  // Currently import the text, but in the future, we could update the HeroSubpage component to accept RichText field
  // -> we can then allow the marketing team to specify h1/h2/h3 etc title tags flexibly
  const title = slice.primary.section_title.text;
  const ingress = slice.primary.ingress;
  const image = slice.primary.image;

  // Use classes from ThemeContext if they are present - otherwise use slice's defaults
  const titleClass = classNames({
    [css.heroSubpageTitle]: !!css.heroSubpageTitle,
    [css_slice.title]: !css.heroSubpageTitle,
  });
  const ingressClass = classNames({
    [css.heroSubpageIngresssubPageIngress]: !!css.heroSubpageIngresssubPageIngress,
    [css_slice.ingress]: !css.heroSubpageIngresssubPageIngress,
  });
  const wrapperClass = classNames({
    [css.heroSubpagewrapperClassName]: !!css.heroSubpagewrapperClassName,
  });

  return (
    <HeroSubpage
      title={title}
      ingress={ingress}
      image={image}
      subtitle={slice.primary.eyebrow}
      wrapperClassName={wrapperClass}
      titleClassName={titleClass}
      ingressClassName={ingressClass}
      imageClassName={css_slice.image}
      typewriterWords={slice.primary.typewriter_words}
      contentBelow={
        slice.primary.cta_text && (
          <PrismicButton to={slice.primary.cta_link.url} theme="positive">
            {slice.primary.cta_text}
          </PrismicButton>
        )
      }
    />
  );
};

export const query = graphql`
  fragment LandingPageDataBodyHeroSubpage on PrismicLandingPageDataBodyHeroSubpage {
    primary {
      eyebrow
      ingress
      section_title {
        text
      }
      typewriter_words
      cta_text
      cta_link {
        url
      }
    }
  }
  fragment PricingDataBodyHeroSubpage on PrismicPricingDataBodyHeroSubpage {
    primary {
      eyebrow
      ingress
      section_title {
        text
      }
      typewriter_words
    }
  }
`;

export default SliceHeroSubpage;
